import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const { t } = useLang();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    if (user && user.role) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        const res = await login(email, password);
        setBusy(false);
        if (res.ok) nav("/admin");
        else setError(res.error || t.admin.invalid_credentials);
    };

    return (
        <div className="flex min-h-[80vh] items-center justify-center px-6" data-testid="admin-login-page">
            <form onSubmit={submit} className="glass p-10 w-full max-w-md" data-testid="login-form">
                <Lock size={22} style={{ color: "var(--ls-terracotta)" }} />
                <h1 className="mt-6 font-display text-3xl font-bold">{t.admin.login}</h1>
                <p className="mt-2 text-sm text-neutral-500">LS39 Admin · Yamaha Mallorca</p>

                <div className="mt-8 space-y-5">
                    <div className="flex flex-col gap-2">
                        <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">{t.admin.email}</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            data-testid="admin-email-input"
                            className="bg-transparent border-b border-black/20 py-3 text-neutral-900 focus:outline-none focus:border-[--ls-blue]"
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">{t.admin.password}</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="admin-password-input"
                            className="bg-transparent border-b border-black/20 py-3 text-neutral-900 focus:outline-none focus:border-[--ls-blue]"
                        />
                    </div>
                </div>

                {error && (
                    <p className="mt-4 font-mono text-xs uppercase tracking-[0.18em] text-red-400" data-testid="login-error">
                        {error}
                    </p>
                )}

                <button type="submit" disabled={busy} className="btn-primary mt-8 w-full" data-testid="admin-login-submit">
                    {busy ? "…" : t.admin.login}
                </button>
            </form>
        </div>
    );
}
